import * as React from "react";

const ProductListingsRestriction: React.FC = () => {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g fill="none" fillRule="evenodd" transform="translate(2.125 2.375)">
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M2.25000054,0 L0.33430481,4.5 L7.3125,4.5 L7.3125,0 L2.25000054,0 Z M8.4375,4.5 L15.2485992,4.5 L13.5,0 L8.4375,0 L8.4375,4.5 Z M15.75,5.625 L0,5.625 L0,15.75 L15.75,15.75 L15.75,5.625 Z"
                />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M2.09531271,4.5 L3.34687543,1.6875 L7.03125054,1.6875 L7.03125054,4.5 L2.09531271,4.5 L2.09531271,4.5 Z M8.71875054,4.5 L8.71875054,1.6875 L12.4031251,1.6875 L13.6546878,4.5 L8.71875054,4.5 Z M14.0625005,6.1875 L14.0625005,14.0625 L1.68750054,14.0625 L1.68750054,6.1875 L14.0625005,6.1875 Z M13.5000005,0 L2.25000054,0 L5.36441803e-07,5.0625 L5.36441803e-07,14.0625 L5.36441803e-07,15.75 L1.68750054,15.75 L14.0625005,15.75 L15.7500005,15.75 L15.7500005,14.0625 L15.7500005,5.0625 L13.5000005,0 Z"
                />
                <path
                    fill="#F9151E"
                    fillRule="nonzero"
                    d="M7.875,7.125 C9.53185425,7.125 10.875,8.46814575 10.875,10.125 C10.875,11.7818542 9.53185425,13.125 7.875,13.125 C6.21814575,13.125 4.875,11.7818542 4.875,10.125 C4.875,8.46814575 6.21814575,7.125 7.875,7.125 Z M5.875,10.125 C5.875,11.0569128 6.51237692,11.8399582 7.37498077,12.0619863 L7.37498077,8.18801369 C6.51237692,8.41004178 5.875,9.19308721 5.875,10.125 Z M8.37602216,8.18827212 L8.37602216,12.0617279 C9.23811707,11.8393512 9.875,11.0565516 9.875,10.125 C9.875,9.19344842 9.23811707,8.41064881 8.37602216,8.18827212 Z"
                    transform="rotate(45 7.875 10.125)"
                />
            </g>
        </svg>
    );
};

export default React.memo(ProductListingsRestriction);
